<template>
<div class="createPopper">
    <moo-popover popper-class="common-popper create-popper" placement="bottom-end" width="160" trigger="hover" :close-delay="0" v-model="addVisible">
      <div class="create-file-popper">
        <span @click="(event) => handleCreate(data.type)" :key="data?.icon" v-for="data in headerAdd">
          <moo-tooltip effect="light" :content="data.tip" placement="right" popper-class="home-create-tooltip-class" :visible-arrow="false" :disabled="!(data.tip !== '')">
            <div class="create-tip">
            <svg-icon class-name="file-icon" :icon-class="data.icon"></svg-icon>
            {{ data?.resourceName }}
          </div>
          </moo-tooltip>
        </span>
      </div>
      <div class="create" slot="reference">
        <svg-icon class-name="create-icon" icon-class="home-create"></svg-icon>
        <div class="content">
          <div class="title">{{$t("新建#!!!#src/pages/CloudHome/components/CreatePopper.vue_1")}}</div>
          <div class="tip">{{$t("新建文档开始协作#!!!#src/pages/CloudHome/components/CreatePopper.vue_1")}}</div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.21428571 4.64285714" class="download-btn-icon design-iconfont">
          <path id="file-unselected-svg" d="M2.65690708,8.3711928 C2.44769764,8.58040224 2.44769764,8.91959776 2.65690708,9.1288072 C2.86611652,9.33801665 3.20531205,9.33801665 3.41452149,9.1288072 L6.98595006,5.55737863 C7.1951595,5.34816919 7.1951595,5.00897367 6.98595006,4.79976422 L3.41452149,1.22833565 C3.20531205,1.01912621 2.86611652,1.01912621 2.65690708,1.22833565 C2.44769764,1.43754509 2.44769764,1.77674062 2.65690708,1.98595006 L5.84952845,5.17857143 L2.65690708,8.3711928 Z" fill="#646A73" fill-rule="nonzero" transform="rotate(90 5.892857 3.392856)"></path>
        </svg>
      </div>
    </moo-popover>

    <MkdirDialog @refresh="refresh" ref="mkdir"></MkdirDialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import MkdirDialog from "./mkdirDialog.vue";
export default {
  props: {},
  name: "CreatePopper",
  components: {
    MkdirDialog
  },
  data() {
    return {
      addVisible: false
    };
  },
  methods: {
    refresh() {
      // 新建刷新列表
      this.$emit("refresh");
    },
    handleCreate(value) {
      if (value == "FOLDER") {
        // 新建文件夹
        this.$refs.mkdir.handleFolderDialog(true);
        return;
      }
      this.$emit("handleCreate", value);
      this.addVisible = false;
    }
  },
  computed: {
    headerAdd() {
      return [
      {
        resourceName: intl.$t("新建文档#!!!#src/pages/CloudHome/components/CreatePopper.vue_1"),
        icon: "cloud-online-doc",
        type: "DOCUMENT",
        tip: ""
      },
      {
        resourceName: intl.$t("新建表格#!!!#src/pages/CloudHome/components/CreatePopper.vue_1"),
        icon: "file-excel",
        type: "EXCEL",
        tip: ""
      },
      {
        resourceName: intl.$t("新建演示文稿#!!!#src/pages/CloudHome/components/CreatePopper.vue_1"),
        icon: "file-ppt",
        type: "PPT",
        tip: ""
      },
      {
        resourceName: intl.$t("新建office文档#!!!#src/pages/CloudHome/components/CreatePopper.vue_1"),
        icon: "file-wps",
        type: "WORD",
        tip: ""
      },
      {
        resourceName: intl.$t("新建文件夹#!!!#src/pages/CloudHome/components/CreatePopper.vue_1"),
        icon: "cloud-folder",
        type: "FOLDER",
        tip: ""
      }];

    }
  },
  watch: {},
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss">
.createPopper {
  width: 220px;
  height: 58px;
}
.common-popper {
  width: 146px !important;
  background: transparent !important;
  height: 112px;
  background: #ffffff;
  border: none !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  box-sizing: border-box;
  height: auto !important;
  width: 146px !important;
  margin-top: 8px !important;
  padding: 8px 0 0 0 !important;

  .popper__arrow {
    display: none !important;
  }
}

.common-popper.create-popper {
  top: 112px !important;
  width: 220px !important;
  margin-top: 8px !important;
}

.header-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 16px !important;
  height: 16px !important;
}

.header-icon:hover {
  background: #f4f6f9;
  border-radius: 4px;
}

.create {
  width: 220px;
  height: 58px;
  background: #ffffff;
  border: 1px solid #efeff0;
  border-radius: 6px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  box-sizing: border-box;

  .create-icon {
    width: 26px;
    height: 26px;
  }

  .content {
    flex: 1;
    padding: 0 16px;
    box-sizing: border-box;
    .title {
      line-height: 20px;
      margin-bottom: 1px;
      font-weight: 500;
      font-size: 14px;
    }

    .tip {
      line-height: 17px;
      font-weight: 400;
      font-size: 12px;
      color: #646573;
    }
  }

  .download-btn-icon {
    width: 10px;
    height: 10px;
    margin-left: 4px;
  }
}

.create:hover {
  border: 1px solid #5c70ff;
}

.create:hover {
  .download-btn-icon {
    #file-unselected-svg {
      fill: #5c70ff !important;
    }
    transform: rotate(180deg);
  }
}

.create-file-popper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;
  padding: 4px 4px !important;
  border-radius: 8px !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  background-color: #ffffff !important;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 100%;
    height: 44px;
    padding-bottom: 4px;
    border-radius: 8px;
    line-height: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;

    .create-tip {
      width: 212px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 0 8px;
    }

    .upload-file {
      width: 16px;
      height: 16px;
      margin: 0 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
    }
  }
}
</style>

<style lang="scss">
.home-create-tooltip-class {
    width: 171px !important;
    padding: 12px 8px !important;
    border-radius: 8px !important;
    background: #FFFFFF !important;
    border: 1px solid #E6E8EC !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    color: #8d8f99 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
}
</style>
